export default __webpack_public_path__ + "static/media/leader_notes_detailed.0f2196a1.pdf";